var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:{ impersonating: _vm.impersonating }},[_c('AppHeader'),_vm._v(" "),(_vm.impersonating)?_c('b-navbar',{staticClass:"impersonate-nav-bar",attrs:{"toggleable":"md","type":"dark","variant":"danger"}},[_c('div',[_vm._v("You are now impersonating "),_c('strong',[_vm._v(_vm._s(_vm.fullName))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{staticClass:"mb-0",attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{class:{
        container: _vm.containerNormal,
        'container-fluid': _vm.containerFluid,
        'h-100': _vm.fillHeight,
        'overflow-hidden': _vm.fillHeight
        }},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-566aabd5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 2275
// module chunks = 0